import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, Pagination } from "../common";

const RequestingApproval = () => {
  return (
    <div>
      <PageTitle title='Requesting Approval' role='Risk Manager' />
      <ParaTitle paraTitle='How To Start' />
      <Paragraph paragraph='Log in and look at your dashboard. Any events that are eligible to be requested for approval will be in the "Review Completed" tab of the dashboard.' />
      <ParaImageDialog src='/tutorial_image/requesting-approval-1.png' />
      <Paragraph paragraph='In the "Review Completed" tab click on the event ID you wish to request for approval. This will take you to that event&#39;s event summary page. In the event summary page click on the "Actions" button in the top right corner and select "Request Approval" in the drop down menu.' />
      <ParaImageDialog src='/tutorial_image/requesting-approval-2.png' />
      
      <Pagination
        pagination={{
          prev: { name: 'User Management', link: '/risk-manager/user-management' },
          next: { name: 'Complete Review', link: '/reviewer/complete-review' }
        }}
      />
    </div>
  );
};

export default RequestingApproval;
